import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableFooter from '@material-ui/core/TableFooter'
import TablePagination from '@material-ui/core/TablePagination'
import TableRow from '@material-ui/core/TableRow'
import IconButton from '@material-ui/core/IconButton'
import FirstPageIcon from '@material-ui/icons/FirstPage'
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft'
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight'
import LastPageIcon from '@material-ui/icons/LastPage'
import TableHead from '@material-ui/core/TableHead'
import cx from 'classnames'
import { SearchIcon } from '../app-icon/Icons'
import ChangebleCostDialog from '../app-form/ChangebleCostDialog'

const actionsStyles = theme => ({
  root: {
    flexShrink: 0,
    color: theme.palette.text.secondary,
    marginLeft: theme.spacing.unit * 2.5,
  },
})

class TablePaginationActions extends React.Component {
  handleFirstPageButtonClick = event => {
    this.props.onChangePage(event, 0)
  }

  handleBackButtonClick = event => {
    this.props.onChangePage(event, this.props.page - 1)
  }

  handleNextButtonClick = event => {
    this.props.onChangePage(event, this.props.page + 1)
  }

  handleLastPageButtonClick = event => {
    this.props.onChangePage(
      event,
      Math.max(0, Math.ceil(this.props.count / this.props.rowsPerPage) - 1)
    )
  }

  render() {
    const { classes, count, page, rowsPerPage, theme } = this.props

    return (
      <div className={classes.root}>
        <IconButton
          onClick={this.handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="First Page"
        >
          {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton
          onClick={this.handleBackButtonClick}
          disabled={page === 0}
          aria-label="Previous Page"
        >
          {theme.direction === 'rtl' ? (
            <KeyboardArrowRight />
          ) : (
            <KeyboardArrowLeft />
          )}
        </IconButton>
        <IconButton
          onClick={this.handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="Next Page"
        >
          {theme.direction === 'rtl' ? (
            <KeyboardArrowLeft />
          ) : (
            <KeyboardArrowRight />
          )}
        </IconButton>
        <IconButton
          onClick={this.handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="Last Page"
        >
          {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </div>
    )
  }
}

const TablePaginationActionsWrapped = withStyles(actionsStyles, {
  withTheme: true,
})(TablePaginationActions)

const CustomTableCell = withStyles(theme => ({
  root: {
    fontFamily: 'Roboto',
    fontSize: 12,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    color: 'rgb(0, 0, 0, .5)',
    padding: '4px 20px 4px 0',
    borderBottom: '1px solid rgba(0, 0, 0, 0.02)',
    backgroundColor: '#fff',
    wordBreak: 'break-word',
  },
}))(TableCell)

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
  },
  table: {
    minWidth: 500,
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  tablecell: {
    fontFamily: 'Roboto',
    fontSize: 12,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    color: 'rgb(0, 0, 0, .5)',
    padding: '4px 0 4px 0',
    borderBottom: '1px solid rgba(0, 0, 0, 0.02)',
    backgroundColor: '#fff',
    wordBreak: 'break-word',
  },
  search: {
    position: 'relative',
    '& input': {
      padding: '6px 17px 6px 0',
      borderWidth: 0,
      borderBottom: 'solid 1px rgb(187, 187, 187)',
      borderRadius: 0,
      outline: 'none',
    },
  },
  searchIcon: {
    position: 'absolute',
    bottom: 4,
    right: 4,
    border: 0,
    padding: '0 3px',
  },
  tabsRoot: {
    minHeight: 0,
    borderBottom: '1px solid #f5f5f5',
  },
  tabsIndicator: {
    backgroundColor: '#8866ff',
  },
  filterMonth: {
    borderBottom: '2px solid #f5f5f5',
  },
  filterMonthBtn: {
    position: 'relative',
    fontFamily: 'Roboto',
    fontSize: 12,
    lineHeight: 1.33,
    color: '#000000',
    border: 0,
    outline: 0,
    padding: 0,
    marginRight: 30,
    paddingBottom: 6,
    cursor: 'pointer',
    background: 'transparent'
  },
  activeMonth: {
    position: 'relative',
    '&::after': {
      content: '" "',
      position: 'absolute',
      bottom: -2,
      left: 0,
      height: 2,
      width: '100%',
      backgroundColor: '#8866ff',
    },
  },
  status: {
    display: 'inline-block',
    width: 16,
    height: 16,
    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16'%3E%3Cpath fill='%23BBB' fill-rule='evenodd' d='M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.75-4.75a.75.75 0 1 1-1.5 0V7.667a.75.75 0 0 1 .252-.56l3.44-3.17a.75.75 0 0 1 .996 1.122L8.75 8.003v3.247z'/%3E%3C/svg%3E%0A")`
  },
  statusProcessing: {
    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16'%3E%3Cpath fill='%23FFC356' fill-rule='evenodd' d='M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM5 9a1 1 0 1 1 0-2 1 1 0 0 1 0 2zM2 9a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm9.648-2l-.364-.36a.954.954 0 0 1 0-1.359.978.978 0 0 1 1.373 0l2.059 2.038c.19.188.284.435.284.681a.953.953 0 0 1-.284.68l-2.06 2.039a.978.978 0 0 1-1.372 0 .954.954 0 0 1 0-1.359l.364-.36H8a1 1 0 1 1 0-2h3.648z'/%3E%3C/svg%3E%0A")`
  },
  statusCompleted: {
    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16'%3E%3Cpath fill='%2350B077' fill-rule='evenodd' d='M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm3.26-11.171a1 1 0 0 1 1.48 1.345l-5 5.5a1 1 0 0 1-1.447.035l-3-3a1 1 0 0 1 1.414-1.415l2.259 2.259 4.294-4.724z'/%3E%3C/svg%3E%0A")`
  }
})

class ChangableCost extends Component {
  state = {
    openEditDialog: false,
    dialogValue: '',
  }

  handleShowEditForm = event => {

    if (!this.props.editable) {
      return false;
    }

    this.setState({
      openEditDialog: true,
      dialogValue: event.target.textContent,
    })
  }

  handleCloseEditDialog = event => {
    this.setState({ openEditDialog: false })
  }

  getCost = () => {
    const cost = parseFloat(this.props.cost)
    return cost.toFixed(2)
  }

  render() {
    const { dialogValue, openEditDialog } = this.state

    return (
      <div style={{ position: 'relative' }}>
        <span
          style={{
            padding: '0 0 3px 0',
            color: '#000',
            borderBottom: this.props.editable
              ? '1px dashed #8866ff'
              : '0'
          }}
          onClick={this.handleShowEditForm}
        >
          {this.getCost()}
        </span>{' '}
        руб
        <ChangebleCostDialog
          rowId={this.props.rowId}
          show={this.state.openEditDialog}
          onClose={this.handleCloseEditDialog}
          onUpdate={this.props.onUpdate}
          initialValues={openEditDialog ? { cost: dialogValue } : {}}
        />
      </div>
    )
  }
}

class TableManualCosting extends Component {
  state = {
    tabValue: 0,
    rows: [],
    page: 0,
    rowsPerPage: 10,
    terms: {
      source: '',
      medium: '',
      campaign: '',
    },
    periods: window.state.periods.reverse(),
  }

  handleChangeTab = (event, value) => {
    console.log(event, value)
  }

  handleChangePage = (event, page) => {
    this.setState({ page })
  }

  handleChangeRowsPerPage = event => {
    this.setState({ page: 0, rowsPerPage: Number(event.target.value) })
  }

  search = (items, terms) => {
    if (
      terms.source.toLowerCase().length === 0 &&
      terms.medium.toLowerCase().length === 0 &&
      terms.campaign.toLowerCase().length === 0
    )
      return items

    return items.filter(item => {
      return (
        item.source.toLowerCase().indexOf(terms.source.toLowerCase()) > -1 &&
        item.medium.toLowerCase().indexOf(terms.medium.toLowerCase()) > -1 &&
        item.campaign.toLowerCase().indexOf(terms.campaign.toLowerCase()) > -1
      )
    })
  }

  onSearchChange = () => {
    this.setState(prevState => ({
      terms: {
        ...prevState.terms,
        [event.target.name]: event.target.value,
      },
    }))
  }

  searchByMonth = event => {
    this.setState({
      filterByMonth: event.target.getAttribute('month'),
      selectedBtnMonth: event.target.getAttribute('month'),
      page: 0,
    })
  }

  componentDidMount() {
    const initialMonth = this.state.periods[0].month

    this.setState({
      rows: this.props.data,
      filterByMonth: initialMonth,
      selectedBtnMonth: initialMonth,
    })
  }

  filterMonth = items =>
    items.filter(item => item.month == this.state.filterByMonth)

  handleUpdateRow(row) {
    var rows = this.state.rows

    for (var i in rows) {
      if (rows[i].id == row.id) {
        rows[i] = row
      }
    }

    this.setState({ rows })
  }

  getTextStatus(status) {
    const statuses = {
      0: '-',
      1: 'Отправка в Google Analytics',
      2: 'Отправлено в Google Analytics'
    }
    return statuses[status];
  }

  render() {
    const { classes } = this.props

    const {
      rows,
      rowsPerPage,
      page,
      terms,
      periods,
      selectedBtnMonth,
    } = this.state

    const emptyRows =
      rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage)

    const month = {
      1: 'Январь',
      2: 'Февраль',
      3: 'Март',
      4: 'Апрель',
      5: 'Май',
      6: 'Июнь',
      7: 'Июль',
      8: 'Август',
      9: 'Сентябрь',
      10: 'Октябрь',
      11: 'Ноябрь',
      12: 'Декабрь',
    }

    const visibleItems = this.search(this.filterMonth(rows), terms)

    return (
      <div className={classes.tableWrapper}>
        <div className={classes.filterMonth}>
          {periods.map(period => (
            <button
              key={period.month}
              month={period.month}
              onClick={this.searchByMonth}
              className={cx(classes.filterMonthBtn, {
                [classes.activeMonth]: selectedBtnMonth == period.month,
              })}
            >
              {month[period.month]}
            </button>
          ))}
        </div>

        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <CustomTableCell
                component="td"
                scope="col"
                style={{ width: 100 }}
              >
                <div className={cx(classes.search)}>
                  <input
                    name="source"
                    type="text"
                    placeholder="Source"
                    style={{ width: 100 }}
                    onChange={this.onSearchChange}
                  />
                  <span type="button" className={classes.searchIcon}>
                    <SearchIcon
                      width={11}
                      height={11}
                      stroke={'rgba(0, 0, 0, .3)'}
                    />
                  </span>
                </div>
              </CustomTableCell>
              <CustomTableCell
                component="td"
                scope="col"
                style={{ width: 100 }}
              >
                <div className={cx(classes.search)}>
                  <input
                    name="medium"
                    type="text"
                    placeholder="Medium"
                    style={{ width: 80 }}
                    onChange={this.onSearchChange}
                  />
                  <span className={classes.searchIcon}>
                    <SearchIcon
                      width={11}
                      height={11}
                      stroke={'rgba(0, 0, 0, .3)'}
                    />
                  </span>
                </div>
              </CustomTableCell>
              <CustomTableCell
                component="td"
                scope="col"
                style={{ width: 100 }}
              >
                <div className={cx(classes.search)}>
                  <input
                    name="campaign"
                    type="text"
                    placeholder="Campaign"
                    style={{ width: 100 }}
                    onChange={this.onSearchChange}
                  />
                  <span className={classes.searchIcon}>
                    <SearchIcon
                      width={11}
                      height={11}
                      stroke={'rgba(0, 0, 0, .3)'}
                    />
                  </span>
                </div>
              </CustomTableCell>
              <CustomTableCell component="td" scope="col" style={{ width: 70 }}>
                <span style={{ width: 50 }}>Сессии</span>
              </CustomTableCell>
              <CustomTableCell component="td" scope="col">
                Расходы
              </CustomTableCell>
              <CustomTableCell component="td" scope="col" align="center">
                Статус
              </CustomTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {visibleItems
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map(item => (
                <TableRow key={item.id}>
                  <TableCell
                    classes={{
                      body: classes.tablecell,
                    }}
                    component="td"
                  >
                    <div style={{ width: 100 }}>{item.source}</div>
                  </TableCell>
                  <TableCell
                    classes={{
                      body: classes.tablecell,
                    }}
                    component="td"
                  >
                    <div style={{ width: 60 }}>{item.medium}</div>
                  </TableCell>
                  <TableCell
                    classes={{
                      body: classes.tablecell,
                    }}
                    component="td"
                  >
                    <div style={{ width: 100 }}>{item.campaign}</div>
                  </TableCell>
                  <TableCell
                    classes={{
                      body: classes.tablecell,
                    }}
                    component="td"
                  >
                    <div style={{ width: 50 }}>{item.sessions}</div>
                  </TableCell>
                  <TableCell
                    style={{ width: 120 }}
                    classes={{
                      body: classes.tablecell,
                    }}
                    component="td"
                  >
                    <ChangableCost
                      rowId={item.id}
                      cost={item.cost}
                      onUpdate={(row) => this.handleUpdateRow(row)}
                      editable={item.canEdit}
                    />
                    {/* {parseInt(item.cost * 100) / 100}
                    {` руб.`} */}
                  </TableCell>
                  <TableCell
                    style={{ width: 120 }}
                    classes={{
                      body: classes.tablecell,
                    }}
                    component="td"
                    align="center"
                  >
                    <span
                      className={
                        cx(classes.status, {
                          [classes.statusProcessing]: item.status == 1,
                          [classes.statusCompleted]: item.status == 2
                        })
                      }
                      title={this.getTextStatus(item.status)}
                    />
                  </TableCell>
                </TableRow>
              ))}
            {emptyRows > 0 && (
              <TableRow style={{ height: 48 * emptyRows }}>
                <TableCell
                  style={{ width: 120 }}
                  classes={{
                    body: classes.tablecell,
                  }}
                  colSpan={5}
                />
              </TableRow>
            )}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                colSpan={3}
                count={visibleItems.length}
                rowsPerPage={rowsPerPage}
                page={page}
                labelDisplayedRows={({ from, to, count }) =>
                  `${from}-${to} из ${count}`
                }
                labelRowsPerPage="Строк на странице"
                SelectProps={{
                  native: true,
                }}
                onChangePage={this.handleChangePage}
                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActionsWrapped}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </div>
    )
  }
}

export default withStyles(styles)(TableManualCosting)
